// Avatar réutilisable d'un collaborateur : affiche sa PHOTO si disponible, sinon
// un repli propre avec ses INITIALES. Toute image cassée bascule automatiquement
// sur les initiales (jamais de vignette cassée). Charte Shariti (crème + orange).
import { useState, useEffect } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function initials(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// Construit l'URL de la photo pour les pages PUBLIQUES (dispatch/pointage) à partir
// d'un membre renvoyé par l'API (champs ``has_photo`` + ``rd_id``).
export function rdPhotoSrc(member) {
  if (!member || !member.has_photo || !member.rd_id) return null;
  return `${BACKEND}/api/pointage/public/rd-photo/${member.rd_id}`;
}

export function RecruiterAvatar({ name, src, size = 36, className = "", testid }) {
  const [err, setErr] = useState(false);
  useEffect(() => { setErr(false); }, [src]);
  const dim = { width: size, height: size };
  const showImg = src && !err;
  return (
    <span
      data-testid={testid}
      className={`relative inline-grid shrink-0 place-items-center overflow-hidden rounded-full bg-[var(--surface-2)] font-extrabold text-[var(--shariti-orange)] ring-1 ring-[var(--border-soft)] ${className}`}
      style={dim}
    >
      {showImg ? (
        <img
          src={src}
          alt=""
          loading="lazy"
          onError={() => setErr(true)}
          className="h-full w-full object-cover"
          style={dim}
        />
      ) : (
        <span style={{ fontSize: Math.max(10, Math.round(size * 0.36)) }}>{initials(name)}</span>
      )}
    </span>
  );
}
